<template>
  <div :class="isFlex ? 'flex_wrap' : 'no_flex'">
    <div v-if="['1', '2', '4', '7', '8'].includes(prescripType)">
      <div
        v-for="(item, i) in drugShowList"
        :key="i"
        :class="i > 0 ? 'drug_wrap border_style' : 'drug_wrap'"
      >
        <div v-if="showPrescripType" class="prescrip-type">
          <span class="prescrip-type__text">
            {{ getKeyValueText('prescrip_type', prescripType) }}处方
          </span>
        </div>
        <template v-if="['1', '2', '8'].includes(prescripType)">
          <div class="row_wrap between" style="margin-bottom: 0.341333rem; align-items: center">
            <div>
              <span class="drug_name">{{ item.drugName }}</span>
            </div>
            <span class="price">¥ {{ showPrice(item) }}</span>
          </div>
          <div class="row_wrap between">
            <div>
              <span class="specification">{{ item.drugSpec }}</span>
              <span class="amount">
                ×{{ item.amount }}{{ getKeyValueText('package_unit', item.packageUnit) }}
              </span>
            </div>
            <div>
              <div v-if="showLeaflet" class="check-leaflet" @click="handleCheckLeaflet(item)">
                查看说明书
              </div>
            </div>
          </div>
          <div class="row_wrap between">
            <div>
              <span class="drug_usage">用法：</span>
              <span class="drug_usage_con">
                {{
                  getKeyValueText('drug_usage_his', item.drugUsage) +
                  '，' +
                  item.useAuantity +
                  (item.measureUnit || (item.drugItem && item.drugItem.measureUnit)
                    ? getKeyValueText('measure_unit', item.measureUnit || item.drugItem.measureUnit)
                    : '') +
                  '，' +
                  getKeyValueText('frequence_his', item.frequence)
                }}
              </span>
            </div>
            <div style="display: flex">
              <div v-if="ifUpdate" @click="editDrug(item, i)">
                <span class="edit_drug">编辑</span>
              </div>
              <div v-if="!prescription && ifUpdate" @click="deleteDrug(i, item.drugFlag)">
                <span class="delete_drug">删除</span>
              </div>
            </div>
          </div>
          <div v-if="item.attention" class="row_wrap">
            <span class="entrust">嘱托：</span>
            <span class="entrust">{{ item.attention }}</span>
          </div>
        </template>
        <template v-else-if="['4', '7'].includes(prescripType)">
          <div class="row_wrap">
            <div
              :class="
                item.isDrugInducer && item.isDrugInducer !== '0' && item.isDrugInducer !== 'false'
                  ? 'left_text'
                  : 'no_left_text'
              "
            >
              <span v-if="item.index === 0" class="['useDrugTime','mdrug']">
                {{ getKeyValueText('drug_use_time', item.useDrugTime) }}
              </span>
              <span
                v-if="
                  item.isDrugInducer && item.isDrugInducer !== '0' && item.isDrugInducer !== 'false'
                "
                class="['inducer','mdrug']"
              >
                
              </span>
            </div>
            <div class="right_text price_row">
              <div
                :class="
                  item.isDrugInducer &&
                  item.isDrugInducer !== '0' &&
                  item.isDrugInducer !== 'false' &&
                  item.index === 0
                    ? 'short'
                    : 'long'
                "
              >
                <span class="colon">:</span>
                <span class="mdrug">{{ item.drugName }}</span>
                <!-- 一人一方特有含量字段 -->
                <span class="mdrug">
                  {{
                    (item.drugSpec || item.drugContent) +
                    ' × ' +
                    item.amount +
                    ' ' +
                    getKeyValueText('package_unit_meng', item.packageUnit)
                  }}
                </span>
              </div>
              <div>
                <!-- 一人一方模板类型修改为4 -->
                <div
                  v-if="showLeaflet && templateType !== '4'"
                  class="check-leaflet"
                  @click="handleCheckLeaflet(item)"
                >
                  查看说明书
                </div>
                <span v-if="templateType !== '4'" class="drug_price">
                  ¥ {{ showPrice(item) }}
                </span>
              </div>
            </div>
          </div>
          <div class="row_wrap">
            <div
              :class="
                item.isDrugInducer && item.isDrugInducer !== '0' && item.isDrugInducer !== 'false'
                  ? 'left_text'
                  : 'no_left_text'
              "
            />
            <div class="bottom_box">
              <div class="right_text right_pad">
                <span class="mdrug">
                  {{
                    item.useAuantity +
                    ' ' +
                    getKeyValueText('measure_unit_meng', item.measureUnit) +
                    ' ×' +
                    item.useDays +
                    ' '
                  }}
                </span>
                <span class="mdrug">
                  {{ getKeyValueText('drug_usage_meng_his', item.drugUsage) }}
                </span>
              </div>
              <!-- 一人一方 -->
              <div
                v-if="prescripType === '7' && drugShowList.length > 0 && i === 0"
                style="display: flex"
              >
                <div v-if="ifUpdate" @click="editDrug(item, i, true)">
                  <span class="edit_drug">编辑</span>
                </div>
                <div
                  v-if="
                    prescripType === '7' && drugShowList.length > 0 && !prescription && ifUpdate
                  "
                  @click="deleteList()"
                >
                  <span class="delete_drug">删除</span>
                </div>
              </div>
              <!-- 正常蒙药 -->
              <div v-if="prescripType === '4'" style="display: flex">
                <div v-if="ifUpdate" @click="editDrug(item, i)">
                  <span class="edit_drug">编辑</span>
                </div>
                <div v-if="!prescription && ifUpdate" @click="deleteDrug(i, item.drugFlag)">
                  <span class="delete_drug">删除</span>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-else>
          <div :class="drugShowList[0] ? 'herbal_row' : 'herbal_data'">
            <div class="herbal_msg">
              <span class="drugName">{{ item.drugName }}</span>
              <span class="useAuantity">
                {{ item.useAuantity
                }}{{
                  getKeyValueText('measure_unit', item.measureUnit || item.drugItem.measureUnit)
                }}
              </span>
              <span>
                {{ item.drugDesc ? '(' : ''
                }}{{ getKeyValueText('prescrip_desc', item.drugDesc) || ''
                }}{{ item.drugDesc ? ')' : '' }}
              </span>
            </div>
            <img
              v-if="!prescription"
              class="deleteDrug"
              src="@funcPuzzle/mini_doctor/deleteDrug.png"
              @click="deleteDrug(i)"
            />
          </div>
        </template>
      </div>
    </div>
    <template v-else>
      <div
        v-for="(item, i) in drugShowList"
        :key="i"
        :class="{ oneline: showLeaflet }"
        class="herbal_wrap"
      >
        <template>
          <div :class="drugShowList[0] ? 'herbal_row' : 'herbal_data'">
            <div class="herbal_msg">
              <div>
                <span class="drugName">{{ item.drugName }}</span>
                <span class="useAuantity">
                  {{ item.useAuantity
                  }}{{
                    getKeyValueText('measure_unit', item.measureUnit || item.drugItem.measureUnit)
                  }}
                </span>
                <span>
                  {{ item.drugDesc ? '(' : ''
                  }}{{ getKeyValueText('prescrip_desc', item.drugDesc) || ''
                  }}{{ item.drugDesc ? ')' : '' }}
                </span>
              </div>
              <div v-if="showLeaflet" class="leaflet-btn" @click="handleCheckLeaflet(item)">
                查看说明书
              </div>
            </div>
            <div style="display: flex">
              <div v-if="ifUpdate" @click="editDrug(item, i)">
                <span class="edit_drug">编辑</span>
              </div>
              <div v-if="!prescription && ifUpdate" @click="deleteDrug(i, item.drugFlag)">
                <span class="delete_drug">删除</span>
              </div>
            </div>
          </div>
        </template>
      </div>
    </template>
  </div>
  <!-- </div> -->
</template>

<script>
import { getKeyValueText } from '@/views/funcPuzzle/utils/util.js'
export default {
  props: {
    drugList: {
      type: [Array],
      default: () => {
        return []
      }
    },
    // 蒙药一人一方操作控制
    onePrescriptionForEachPerson: {
      type: [Boolean],
      default: false
    },
    prescription: {
      type: [String],
      default: ''
    },
    prescripType: {
      type: [String],
      default: ''
    },
    page: {
      type: [String],
      default: ''
    },
    templateType: {
      type: [String],
      default: ''
    },
    showLeaflet: {
      type: Boolean,
      default: false
    },
    ifUpdate: {
      type: Boolean,
      default: false
    },
    preDetail: {
      type: [Object],
      default: () => ({})
    },
    showPrescripType: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      drugShowList: []
    }
  },
  computed: {
    isFlex() {
      return (
        (this.prescripType === '3' || this.prescripType === '5' || this.prescripType === '6') &&
        this.page === '处方笺'
      )
    },
    showPrice(item) {
      // 西药、中成药、蒙药药品金额由单价修改为合计金额
      return function (item) {
        return (item.amount * item.drugPrice).toFixed(2)
      }
    }
  },
  watch: {
    drugList: {
      handler(val) {
        if (['4', '7'].includes(this.prescripType)) {
          this.drugShowList = this.handleList(val, 'useDrugTime')
        } else {
          this.drugShowList = val
        }
      },
      immediate: true
    },
    prescripType(val) {}
  },
  onLoad() {},
  methods: {
    getKeyValueText,
    editDrug(item, index, ifOne) {
      this.$emit('editDrug', {
        drugShowList: this.drugShowList,
        index,
        ifOne,
        preDetail: this.preDetail
      })
    },
    deleteList() {
      uni.showModal({
        title: '提示',
        content: '您确定要删除当前处方吗?',
        success: res => {
          if (res.confirm) {
            this.drugShowList = []
            this.$bus.emit('deleteDrug', this.drugShowList)
          } else if (res.cancel) {
            return false
          }
        }
      })
    },
    deleteDrug(index) {
      // 一人一方操作控制
      this.drugShowList.splice(index, 1)
      this.$bus.emit('deleteDrug', this.drugShowList)
    },
    groupBy(arr, key) {
      const obj = {}
      arr.sort((a, b) => a[key] - b[key])
      arr.map(item => {
        const _key = item[key]
        if (obj[_key]) {
          obj[_key].push(item)
        } else {
          obj[_key] = [item]
        }
      })
      return obj
    },
    handleList(val) {
      if (!val) {
        return []
      }
      // 过滤调没有药品id的药品
      const { result, drugs } = val.reduce(
        (res, item) => {
          // 1过滤调没有药品id的药品
          if (!item.drugID) {
            return res
          }
          // 2按useDrugTime分组,是字符串数字, 分组内在按isDrugInducer分组，是数字字符串
          if (item.useDrugTime == undefined) {
            // useDrugTime：undefined || null的时候设置成0
            item.useDrugTime = '0'
          }
          if (!res.result[item.useDrugTime]) {
            // 用药时间是数字，在这里当作字典的key使用
            res.result[item.useDrugTime] = []
          }
          const group = res.result[item.useDrugTime]
          const key = Number(item.isDrugInducer) || 0
          if (!group[key]) {
            // 有药引是'1',没有是'0'或者空,空回按0处理
            group[key] = []
          }
          res.drugs.push(item)
          return res
        },
        { drugs: [], result: [] }
      )
      // 把药品根据自己的字段放进分组内
      drugs.forEach(item => {
        // isDrugInducer 可能没有药引字段默认是0
        result[item.useDrugTime][item.isDrugInducer || 0].push(item)
      })
      // 把分类的药品数据扁平化
      const list = result.flat(Infinity)
      // 每个分类时段的第一项展示时段字段
      list.reduce((current, item) => {
        item.index = current !== item.useDrugTime ? 0 : 1
        return item.useDrugTime
      }, 'init')
      // console.log(list)
      return list
    },

    handleCheckLeaflet(item) {
      this.$store.dispatch('setLeafletStatus', true)
      this.$store.dispatch('setLeafletData', item)
    }
  },
  unmounted() {
    this.$bus.off('deleteDrug')
  }
}
</script>

<style lang="scss" scoped>
.flex_wrap {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0.682667rem;
  .herbal_wrap {
    min-width: 7.317333rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 1.877333rem;
    line-height: 1.877333rem;
    padding: 0.341333rem 0;
    &.oneline {
      width: 100%;
      justify-content: space-between;
    }
    .leaflet-btn {
      width: 3.072rem;
      height: 1.024rem;
      border-radius: 0.085333rem;
      border: 0.021333rem solid #0089ff;
      font-size: 0.512rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0089ff;
      line-height: 1.024rem;
      text-align: center;
      transform: translateY(-0.32rem);
    }
    .herbal_row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #222;
      font-size: 0.64rem;
      padding: 0 0.682667rem;
      height: 1.194667rem;
      .herbal_msg {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex: 1;
        .drugName {
          display: inline-block;
          margin-right: 0.426667rem !important;
        }
        .useAuantity {
          display: inline-block;
          margin-right: 0.213333rem !important;
        }
      }
      .edit_drug {
        color: #0089ff;
        margin-right: 0.512rem;
      }
      .delete_drug {
        color: #ff7555;
      }
      .deleteDrug {
        width: 0.853333rem;
        height: 0.853333rem;
        background: #ececec;
        border-radius: 50%;
      }
    }
    .herbal_data {
      padding-top: 0;
    }
  }
}
.no_flex {
  width: 100%;
  height: auto;
  background-color: transparent;
  box-sizing: border-box;
  position: relative;
  .prescription_one {
    position: absolute;
    right: 0.618667rem;
    top: 0.362667rem;
    z-index: 999;
    width: 1.024rem;
    height: 1.024rem;
  }
  .herbal_wrap {
    min-width: 7.317333rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 1.877333rem;
    line-height: 1.877333rem;
    padding: 0.341333rem 0;
    .herbal_row {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #222;
      font-size: 0.64rem;
      padding: 0 0.682667rem;
      height: 1.194667rem;
      .herbal_msg {
        display: flex;
        align-items: center;
        .drugName {
          display: inline-block;
          margin-right: 0.426667rem !important;
        }
        .useAuantity {
          display: inline-block;
          margin-right: 0.213333rem !important;
        }
      }
      .edit_drug {
        color: #0089ff;
        margin-right: 0.512rem;
      }
      .delete_drug {
        color: #ff7555;
      }

      .deleteDrug {
        width: 0.853333rem;
        height: 0.853333rem;
        background: #ececec;
        border-radius: 50%;
      }
    }
    .herbal_data {
      padding-top: 0;
    }
  }
}

.drug_wrap {
  // width: 14.634667rem;
  padding: 0.426667rem 0.682667rem;
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  box-sizing: border-box;
  .row_wrap,
  .between {
    display: flex;
    margin-bottom: 0.341333rem;
    position: relative;
    .edit_drug {
      color: #0089ff;
      margin-right: 0.512rem;
    }
    .delete_drug {
      color: #ff7555;
    }
    .left_text,
    .no_left_text {
      min-width: 3em;
      .useDrugTime {
        padding-right: 1em;
      }
      .inducer {
        padding-right: 1em;
      }
    }
    .no_left_text {
      min-width: 3em;
    }
    .bottom_box {
      display: flex;
      justify-content: space-between;
    }
    .right_text {
      display: flex;

      .edit_drug {
        color: #0089ff;
        margin-right: 0.512rem;
      }
      .delete_drug {
        color: #ff7555;
      }
      .short {
        width: 9.642667rem;
      }
      .long {
        width: 10.666667rem;
      }
      .colon {
        margin-right: 0.298667rem;
      }
      text {
        margin-right: 0.597333rem;
      }
      .drug_price {
        margin-right: 0;
      }
    }
    .price_row {
      display: flex;
      justify-content: space-between;
      width: 12.885333rem;
    }
    .right_pad {
      padding-left: 0.64rem;
      width: 9.301333rem;
    }
    .delete_mdrug {
      position: absolute;
      right: 0rem;
      top: 0.213333rem;
      z-index: 999;
      width: 1.024rem;
      height: 1.024rem;
    }
    .deleteDrug {
      width: 0.853333rem;
      height: 0.853333rem;
      background: #ececec;
      border-radius: 50%;
    }
    .drug_name {
      font-size: 0.64rem;
      font-weight: 400;
      color: #222222;
      line-height: 0.64rem;
      margin-right: 0.426667rem;
    }
    .specification,
    .drug_usage,
    .drug_usage_con,
    .entrust {
      font-size: 0.512rem;
      font-weight: 400;
      color: #888;
      line-height: 0.704rem;
      margin-right: 0.426667rem;
    }
    .drug_usage,
    .entrust {
      margin-right: 0;
    }
    .amount {
      color: #888;
      font-size: 0.512rem;
      font-weight: 400;
    }
    .price,
    .drug_price {
      font-size: 0.64rem;
      font-weight: 500;
      color: #ff7555;
      line-height: 0.704rem;
    }
    // .drug_price {
    // }
    .entrust {
      color: #888;
    }

    .check-leaflet {
      width: 3.072rem;
      height: 1.024rem;
      border-radius: 0.085333rem;
      border: 0.021333rem solid #0089ff;
      font-size: 0.512rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #0089ff;
      line-height: 1.024rem;
      text-align: center;
      transform: translateY(-0.32rem);
    }
  }
  .between {
    justify-content: space-between;
  }
  view:last-child {
    margin-bottom: 0;
  }
}
.border_style {
  border-top: 0.021333rem solid #ececec;
}
.prescrip-type {
  margin-bottom: 0.682667rem;
  .prescrip-type__text {
    display: inline-block;
    padding: 0.170667rem;
    background: #e7f4ff;
    border-radius: 0.085333rem;

    font-size: 0.512rem;
    font-weight: 400;
    color: #0089ff;
    text-align: center;
  }
}
</style>
